import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import {
  DoAction,
  GetAppInformation,
  GetCartableActions,
  GetCoreInformation,
  GetSupplierInformation,
} from "../../../services/cartable.service";
import { useMutation, useQueryClient } from "react-query";
import {
  DoActionRequest,
  DoActionResponse,
  GetCartableActionsResponse,
  GetCoreInformationResponse,
  GetSupplierInformationResponse,
} from "../../../models/cartable.model";
import { useHistory } from "react-router-dom";
import { WORK_FLOW_TYPE } from "../../../config/cacheKey";
import { ApiResultModel } from "../../../models/common.model";
import { toast } from "react-toastify";
import ActionTabs from "./actionTab/actionTabs";
import ActionTabsModifid from "./actionTab/actionTabsModifid";
import { v4 as uuid } from "uuid";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  maxWidth: "fit-content !important",
  minWidth: "45vw !important",
};

const Item = styled(Paper)(() => ({
  backgroundColor: "#fff",
  textAlign: "center",
}));
export default function ActionModal({
  openModal,
  description,
  title,
  buttonData,
  icon,
  referenceKey,
  setDataGetCoreInformation,
  setDataGetCartableActions,
  getCartableAction,
  setReload,
  setShowActionBtns,
  setActionModalBtnDisable,
}: any) {
  const queryClient = useQueryClient();
  const [open, setOpen] = React.useState(openModal);
  const [messages, setMessages] = React.useState(description);
  const handleClose = () => {
    setOpen(false);
    setActionModalBtnDisable(false);
  };
  const handleOpen = () => {
    setOpen(true);
    setActionModalBtnDisable(true);
    // getCartableActionsMutation.mutateAsync({
    //   workflowType: wft!,
    //   referenceKey: referenceKey ?? "",
    // });
  };
  const history = useHistory();
  const clickRef = React.useRef(null);
  const supplierId = localStorage.getItem("SUPPLIER_ID");
  //***services detail */
  const getCoreInformationMutation = useMutation(GetCoreInformation, {
    onSuccess: (data: ApiResultModel<GetCoreInformationResponse>) => {
      if (data) {
        setDataGetCoreInformation(data.data);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });
  const getAppInformationMutation = useMutation(GetAppInformation, {
    onSuccess: (data: ApiResultModel<GetCoreInformationResponse>) => {
      if (data) {
        setDataGetCoreInformation(data.data);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });
  const getCartableActionsMutation = useMutation(GetCartableActions, {
    onSuccess: (data: GetCartableActionsResponse[]) => {
      if (data) {
        setDataGetCartableActions(data);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });

  const { mutate: GetSupplierInformationMutate } = useMutation(
    GetSupplierInformation,
    {
      onSuccess: (data: GetSupplierInformationResponse) => {
        if (data) {
          setDataGetCoreInformation(data);
        }
      },
      onError: () => {},
    }
  );

  //***services detail */
  let wft = getCartableAction;
  const doActionMutation = useMutation(DoAction, {
    onSuccess: (data: any) => {
      if (data?.isSuccess) {
        setOpen(false);
        setActionModalBtnDisable(false);
        toast.success(" عملیات با موفقیت انجام شد.");
        if (
          wft == "SupplierSettlementCartable" ||
          wft == "LoanRegistrationBySupplier"
        ) {
          getCoreInformationMutation.mutateAsync({
            referenceKey: referenceKey,
          });
        } else if (wft == "CustomerRegistration") {
          getAppInformationMutation.mutateAsync({ referenceKey: referenceKey });
        } else if (wft === "SupplierRequirements") {
          GetSupplierInformationMutate({
            supplierId: Number(supplierId),
          });
        }
        getCartableActionsMutation.mutateAsync({
          workflowType: wft!,
          referenceKey: referenceKey ?? "",
        });
        setReload(uuid());

        // setReturnPageRef(referenceKey);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });
  // to remove extra service call (getcartablraction)
  // React.useEffect(() => {
  //   debugger;
  //   getCartableActionsMutation.mutateAsync({
  //     workflowType: wft!,
  //     referenceKey: referenceKey ?? "",
  //   });
  // }, []);

  // function refFunction(referenceKey: string) {
  //   history.push({
  //     pathname: `/loan/loan-detail`,
  //     state: { id: referenceKey },
  //   });
  // }
  const handelVerify = () => {
    let doAction = new DoActionRequest();
    doAction.referenceKey = referenceKey;
    doAction.workflowType = getCartableAction;
    doAction.workflowStepType = buttonData.workflowStepType;
    doAction.stepId = buttonData.stepId;
    if (referenceKey) {
      doActionMutation.mutate(doAction!);
    }
  };
  const handelCancel = () => {
    handleClose();
    // getCartableActionsMutation.mutateAsync({
    //   workflowType: wft!,
    //   referenceKey: referenceKey ?? "",
    // });
  };
  React.useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  React.useEffect(() => {
    setMessages(description);
  }, [description]);

  const id = localStorage.getItem("SUPPLIER_ID");
  return (
    <div>
      <div onClick={handleOpen}>
        <span className="cursorPointer">
          {title} {icon}
        </span>
      </div>

      {!getCartableActionsMutation.isLoading && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box
            // sx={{
            //   style,
            //   border:
            //     buttonData.workflowStepType.toLowerCase() === "forward"
            //       ? "2px solid green"
            //       : "2px solid #E57373",
            // }}
            sx={style}
            style={{
              borderRadius: "6px",
              // border:
              //   buttonData.workflowStepType.toLowerCase() === "forward"
              //     ? "2px solid green"
              //     : "2px solid #E57373",
            }}
            className="ModalCmp textCenter "
          >
            <div>
              <Typography className="textCenter mTop30 mbottom20">
                <b className="" style={{ fontSize: "1.1rem" }}>
                  {buttonData.header}
                </b>
              </Typography>
              <Typography
                className="mTop30 mbottom20"
                sx={{ paddingX: "1rem", textAlign: "center" }}
              >
                <span className=""> {description} </span>
              </Typography>
            </div>

            {buttonData.tabs.length > 0 ? (
              <ActionTabsModifid
                setFlagActionTab={true}
                actionTabsData={buttonData}
                referenceKey={
                  wft === "SupplierRequirements" ? id : referenceKey
                }
                setDataGetCoreInformation={setDataGetCoreInformation}
                setDataGetCartableActions={setDataGetCartableActions}
                getCartableAction={getCartableAction}
                closeModal={handelCancel}
                setReload={setReload}
                setShowActionBtns={setShowActionBtns}
              />
            ) : (
              // : buttonData.workflowStepType.toLowerCase() === "backward" ? (
              //   <ActionTabs
              //     setFlagActionTab={true}
              //     actionTabsData={buttonData}
              //     referenceKey={id}
              //     setDataGetCoreInformation={setDataGetCoreInformation}
              //     setDataGetCartableActions={setDataGetCartableActions}
              //     getCartableAction={getCartableAction}
              //   />
              // )
              <>
                {/* {buttonData.showAsModal &&  */}
                <Grid
                  container
                  spacing={2}
                  columns={12}
                  className="mTop20"
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Grid item xs={6} textAlign={"left"}>
                    <Button
                      onClick={handelVerify}
                      // fullWidth
                      sx={{
                        minWidth: "80px",
                        maxWidth: "fit-content",
                        paddingX: "13px",
                      }}
                      className={`btnForm 
                 ${
                   buttonData.workflowStepType.toLocaleLowerCase() === "forward"
                     ? "SuccessDefault"
                     : "DangerDefault"
                 }`}
                      style={{ fontSize: "11px !important" }}
                    >
                      {title}
                    </Button>
                  </Grid>
                  <Grid item xs={6} textAlign={"right"}>
                    <Button
                      onClick={handelCancel}
                      // fullWidth
                      className="btnForm ComingBack "
                      sx={{ minWidth: "130px", maxWidth: "fit-content" }}
                    >
                      بازگشت
                    </Button>
                  </Grid>
                </Grid>
                {/* } */}
              </>
            )}
          </Box>
        </Modal>
      )}
    </div>
  );
}
